/* Use this file to add extend the functionality of the theme. */
$(function() {
    $('#trigger-quickcart').click( e => {
        e.preventDefault();
    
        $('.quick-cart__wrapper').removeClass('active');
    })

    $('.product__option .product__chip').click( e => {
        if ( $(e.target).hasClass('disabled') ) {
            $('.klaviyo-bis-trigger').show();
        } else {
            $('.klaviyo-bis-trigger').hide();
        }
    });
}); // DOM Loaded